import React from 'react';
import TrainingNav from '../../BiteU/BiteUNav';
import TrainingHeader from '../TrainingHeader';
import { Grid } from '@mui/material';
import { Link } from 'react-router-dom';

const TrainingVideos: React.FC = () => {
  return (
    <>
      <TrainingNav
        basePath='Resources / Training / '
        curPath='Training Videos'
      />
      <TrainingHeader title='Training Videos'>
        <Grid
          container
          spacing={2}
          style={{ paddingLeft: '20px', paddingRight: '20px' }}
        >
          <Grid item xs={12} sm={6} md={4}>
            <div className='training-video-card'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11H13.38L13.06 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H14V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18V19Z'
                  fill='var(--text-primary)'
                />
              </svg>
              <div style={{ width: '100%' }}>
                <p className='video-card-title'>Quick Start</p>
                <Link to='/quick-start-video'>
                  <div className='video-card-link'>
                    <p className='video-card-open'>Open</p>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='15'
                      height='13'
                      viewBox='0 0 15 13'
                      fill='none'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M8.63144 12.2551C8.32278 11.9336 8.32278 11.4258 8.63144 11.1042L12.3124 7.31226H0.806427C0.359833 7.30811 0 6.94482 0 6.49829C0 6.05176 0.359833 5.68848 0.806427 5.68433H12.3064L8.62644 1.89429C8.31754 1.57227 8.31754 1.06396 8.62644 0.741943C8.77231 0.589111 8.97431 0.50293 9.18549 0.50293C9.39664 0.50293 9.5986 0.589355 9.74442 0.742187L14.7444 5.89722C14.9091 6.05298 15.0031 6.26929 15.0044 6.49585C15.0057 6.72241 14.9143 6.93994 14.7514 7.09741L9.74142 12.2593C9.59543 12.4116 9.39353 12.4978 9.18244 12.4978C8.97134 12.4978 8.76944 12.4116 8.62341 12.2593L8.63144 12.2551Z'
                        fill='#4895EF'
                      />
                    </svg>
                  </div>
                </Link>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className='training-video-card'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11H13.38L13.06 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H14V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18V19Z'
                  fill='var(--text-primary)'
                />
              </svg>
              <div style={{ width: '100%' }}>
                <p className='video-card-title'>Payments Process</p>
                <Link to='/payments-video'>
                  <div className='video-card-link'>
                    <p className='video-card-open'>Open</p>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='15'
                      height='13'
                      viewBox='0 0 15 13'
                      fill='none'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M8.63144 12.2551C8.32278 11.9336 8.32278 11.4258 8.63144 11.1042L12.3124 7.31226H0.806427C0.359833 7.30811 0 6.94482 0 6.49829C0 6.05176 0.359833 5.68848 0.806427 5.68433H12.3064L8.62644 1.89429C8.31754 1.57227 8.31754 1.06396 8.62644 0.741943C8.77231 0.589111 8.97431 0.50293 9.18549 0.50293C9.39664 0.50293 9.5986 0.589355 9.74442 0.742187L14.7444 5.89722C14.9091 6.05298 15.0031 6.26929 15.0044 6.49585C15.0057 6.72241 14.9143 6.93994 14.7514 7.09741L9.74142 12.2593C9.59543 12.4116 9.39353 12.4978 9.18244 12.4978C8.97134 12.4978 8.76944 12.4116 8.62341 12.2593L8.63144 12.2551Z'
                        fill='#4895EF'
                      />
                    </svg>
                  </div>
                </Link>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className='training-video-card'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11H13.38L13.06 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H14V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18V19Z'
                  fill='var(--text-primary)'
                />
              </svg>
              <div style={{ width: '100%' }}>
                <p className='video-card-title'>Licenses Workflow</p>
                <Link to='/licenses-video'>
                  <div className='video-card-link'>
                    <p className='video-card-open'>Open</p>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='15'
                      height='13'
                      viewBox='0 0 15 13'
                      fill='none'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M8.63144 12.2551C8.32278 11.9336 8.32278 11.4258 8.63144 11.1042L12.3124 7.31226H0.806427C0.359833 7.30811 0 6.94482 0 6.49829C0 6.05176 0.359833 5.68848 0.806427 5.68433H12.3064L8.62644 1.89429C8.31754 1.57227 8.31754 1.06396 8.62644 0.741943C8.77231 0.589111 8.97431 0.50293 9.18549 0.50293C9.39664 0.50293 9.5986 0.589355 9.74442 0.742187L14.7444 5.89722C14.9091 6.05298 15.0031 6.26929 15.0044 6.49585C15.0057 6.72241 14.9143 6.93994 14.7514 7.09741L9.74142 12.2593C9.59543 12.4116 9.39353 12.4978 9.18244 12.4978C8.97134 12.4978 8.76944 12.4116 8.62341 12.2593L8.63144 12.2551Z'
                        fill='#4895EF'
                      />
                    </svg>
                  </div>
                </Link>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className='training-video-card'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11H13.38L13.06 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H14V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18V19Z'
                  fill='var(--text-primary)'
                />
              </svg>
              <div style={{ width: '100%' }}>
                <p className='video-card-title'>BITE U</p>
                <Link to='/bite-u-video'>
                  <div className='video-card-link'>
                    <p className='video-card-open'>Open</p>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='15'
                      height='13'
                      viewBox='0 0 15 13'
                      fill='none'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M8.63144 12.2551C8.32278 11.9336 8.32278 11.4258 8.63144 11.1042L12.3124 7.31226H0.806427C0.359833 7.30811 0 6.94482 0 6.49829C0 6.05176 0.359833 5.68848 0.806427 5.68433H12.3064L8.62644 1.89429C8.31754 1.57227 8.31754 1.06396 8.62644 0.741943C8.77231 0.589111 8.97431 0.50293 9.18549 0.50293C9.39664 0.50293 9.5986 0.589355 9.74442 0.742187L14.7444 5.89722C14.9091 6.05298 15.0031 6.26929 15.0044 6.49585C15.0057 6.72241 14.9143 6.93994 14.7514 7.09741L9.74142 12.2593C9.59543 12.4116 9.39353 12.4978 9.18244 12.4978C8.97134 12.4978 8.76944 12.4116 8.62341 12.2593L8.63144 12.2551Z'
                        fill='#4895EF'
                      />
                    </svg>
                  </div>
                </Link>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className='training-video-card'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11H13.38L13.06 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H14V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18V19Z'
                  fill='var(--text-primary)'
                />
              </svg>
              <div style={{ width: '100%' }}>
                <p className='video-card-title'>BITE Modules Quick Start</p>
                <Link to='/module-quick-start-video'>
                  <div className='video-card-link'>
                    <p className='video-card-open'>Open</p>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='15'
                      height='13'
                      viewBox='0 0 15 13'
                      fill='none'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M8.63144 12.2551C8.32278 11.9336 8.32278 11.4258 8.63144 11.1042L12.3124 7.31226H0.806427C0.359833 7.30811 0 6.94482 0 6.49829C0 6.05176 0.359833 5.68848 0.806427 5.68433H12.3064L8.62644 1.89429C8.31754 1.57227 8.31754 1.06396 8.62644 0.741943C8.77231 0.589111 8.97431 0.50293 9.18549 0.50293C9.39664 0.50293 9.5986 0.589355 9.74442 0.742187L14.7444 5.89722C14.9091 6.05298 15.0031 6.26929 15.0044 6.49585C15.0057 6.72241 14.9143 6.93994 14.7514 7.09741L9.74142 12.2593C9.59543 12.4116 9.39353 12.4978 9.18244 12.4978C8.97134 12.4978 8.76944 12.4116 8.62341 12.2593L8.63144 12.2551Z'
                        fill='#4895EF'
                      />
                    </svg>
                  </div>
                </Link>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className='training-video-card'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11H13.38L13.06 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H14V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18V19Z'
                  fill='var(--text-primary)'
                />
              </svg>
              <div style={{ width: '100%' }}>
                <p className='video-card-title'>BITE Screening</p>
                <Link to='/screening-video'>
                  <div className='video-card-link'>
                    <p className='video-card-open'>Open</p>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='15'
                      height='13'
                      viewBox='0 0 15 13'
                      fill='none'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M8.63144 12.2551C8.32278 11.9336 8.32278 11.4258 8.63144 11.1042L12.3124 7.31226H0.806427C0.359833 7.30811 0 6.94482 0 6.49829C0 6.05176 0.359833 5.68848 0.806427 5.68433H12.3064L8.62644 1.89429C8.31754 1.57227 8.31754 1.06396 8.62644 0.741943C8.77231 0.589111 8.97431 0.50293 9.18549 0.50293C9.39664 0.50293 9.5986 0.589355 9.74442 0.742187L14.7444 5.89722C14.9091 6.05298 15.0031 6.26929 15.0044 6.49585C15.0057 6.72241 14.9143 6.93994 14.7514 7.09741L9.74142 12.2593C9.59543 12.4116 9.39353 12.4978 9.18244 12.4978C8.97134 12.4978 8.76944 12.4116 8.62341 12.2593L8.63144 12.2551Z'
                        fill='#4895EF'
                      />
                    </svg>
                  </div>
                </Link>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className='training-video-card'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11H13.38L13.06 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H14V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18V19Z'
                  fill='var(--text-primary)'
                />
              </svg>
              <div style={{ width: '100%' }}>
                <p className='video-card-title'>BITE Bulk</p>
                <Link to='/bite-bulk-video'>
                  <div className='video-card-link'>
                    <p className='video-card-open'>Open</p>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='15'
                      height='13'
                      viewBox='0 0 15 13'
                      fill='none'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M8.63144 12.2551C8.32278 11.9336 8.32278 11.4258 8.63144 11.1042L12.3124 7.31226H0.806427C0.359833 7.30811 0 6.94482 0 6.49829C0 6.05176 0.359833 5.68848 0.806427 5.68433H12.3064L8.62644 1.89429C8.31754 1.57227 8.31754 1.06396 8.62644 0.741943C8.77231 0.589111 8.97431 0.50293 9.18549 0.50293C9.39664 0.50293 9.5986 0.589355 9.74442 0.742187L14.7444 5.89722C14.9091 6.05298 15.0031 6.26929 15.0044 6.49585C15.0057 6.72241 14.9143 6.93994 14.7514 7.09741L9.74142 12.2593C9.59543 12.4116 9.39353 12.4978 9.18244 12.4978C8.97134 12.4978 8.76944 12.4116 8.62341 12.2593L8.63144 12.2551Z'
                        fill='#4895EF'
                      />
                    </svg>
                  </div>
                </Link>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className='training-video-card'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11H13.38L13.06 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H14V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18V19Z'
                  fill='var(--text-primary)'
                />
              </svg>
              <div style={{ width: '100%' }}>
                <p className='video-card-title'>BITE GPT</p>
                <Link to='/bite-gpt-video'>
                  <div className='video-card-link'>
                    <p className='video-card-open'>Open</p>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='15'
                      height='13'
                      viewBox='0 0 15 13'
                      fill='none'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M8.63144 12.2551C8.32278 11.9336 8.32278 11.4258 8.63144 11.1042L12.3124 7.31226H0.806427C0.359833 7.30811 0 6.94482 0 6.49829C0 6.05176 0.359833 5.68848 0.806427 5.68433H12.3064L8.62644 1.89429C8.31754 1.57227 8.31754 1.06396 8.62644 0.741943C8.77231 0.589111 8.97431 0.50293 9.18549 0.50293C9.39664 0.50293 9.5986 0.589355 9.74442 0.742187L14.7444 5.89722C14.9091 6.05298 15.0031 6.26929 15.0044 6.49585C15.0057 6.72241 14.9143 6.93994 14.7514 7.09741L9.74142 12.2593C9.59543 12.4116 9.39353 12.4978 9.18244 12.4978C8.97134 12.4978 8.76944 12.4116 8.62341 12.2593L8.63144 12.2551Z'
                        fill='#4895EF'
                      />
                    </svg>
                  </div>
                </Link>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className='training-video-card'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11H13.38L13.06 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H14V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18V19Z'
                  fill='var(--text-primary)'
                />
              </svg>
              <div style={{ width: '100%' }}>
                <p className='video-card-title'>BITE Data Modules</p>
                <Link to='/data-modules-video'>
                  <div className='video-card-link'>
                    <p className='video-card-open'>Open</p>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='15'
                      height='13'
                      viewBox='0 0 15 13'
                      fill='none'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M8.63144 12.2551C8.32278 11.9336 8.32278 11.4258 8.63144 11.1042L12.3124 7.31226H0.806427C0.359833 7.30811 0 6.94482 0 6.49829C0 6.05176 0.359833 5.68848 0.806427 5.68433H12.3064L8.62644 1.89429C8.31754 1.57227 8.31754 1.06396 8.62644 0.741943C8.77231 0.589111 8.97431 0.50293 9.18549 0.50293C9.39664 0.50293 9.5986 0.589355 9.74442 0.742187L14.7444 5.89722C14.9091 6.05298 15.0031 6.26929 15.0044 6.49585C15.0057 6.72241 14.9143 6.93994 14.7514 7.09741L9.74142 12.2593C9.59543 12.4116 9.39353 12.4978 9.18244 12.4978C8.97134 12.4978 8.76944 12.4116 8.62341 12.2593L8.63144 12.2551Z'
                        fill='#4895EF'
                      />
                    </svg>
                  </div>
                </Link>
              </div>
            </div>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <div className='training-video-card'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11H13.38L13.06 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H14V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18V19Z'
                  fill='var(--text-primary)'
                />
              </svg>
              <div style={{ width: '100%' }}>
                <p className='video-card-title'>Analytics Vault</p>
                <Link to='/analytics-vault-video'>
                  <div className='video-card-link'>
                    <p className='video-card-open'>Open</p>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='15'
                      height='13'
                      viewBox='0 0 15 13'
                      fill='none'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M8.63144 12.2551C8.32278 11.9336 8.32278 11.4258 8.63144 11.1042L12.3124 7.31226H0.806427C0.359833 7.30811 0 6.94482 0 6.49829C0 6.05176 0.359833 5.68848 0.806427 5.68433H12.3064L8.62644 1.89429C8.31754 1.57227 8.31754 1.06396 8.62644 0.741943C8.77231 0.589111 8.97431 0.50293 9.18549 0.50293C9.39664 0.50293 9.5986 0.589355 9.74442 0.742187L14.7444 5.89722C14.9091 6.05298 15.0031 6.26929 15.0044 6.49585C15.0057 6.72241 14.9143 6.93994 14.7514 7.09741L9.74142 12.2593C9.59543 12.4116 9.39353 12.4978 9.18244 12.4978C8.97134 12.4978 8.76944 12.4116 8.62341 12.2593L8.63144 12.2551Z'
                        fill='#4895EF'
                      />
                    </svg>
                  </div>
                </Link>
              </div>
            </div>
          </Grid>
        </Grid>
      </TrainingHeader>
    </>
  );
};

export default TrainingVideos;
